import { APIProvider } from '@vis.gl/react-google-maps';
import { Col, Row } from 'antd';
import { GOOGLE_MAPS_API_KEY } from 'common/config/constants.config';
import { RowSpacing } from 'component';
import { useExecute } from 'core';
import { useEffect } from 'react';
import ClusterPanel from './element/ClusterPanel';
import GoogleMaps from './element/GoogleMaps';
import ListScreenPanel from './element/ListScreenPanel';
import OfflineFilterPanel from './element/OfflineFilterPanel';
import PositionFiltrePanel from './element/PositionFiltrePanel';
import ScreenStatusMapCtrl from './ScreenStatusMapCtrl';

const ScreenStatusMapView = () => {
    const { execute } = useExecute();

    useEffect(() => {
        execute(ScreenStatusMapCtrl.listScreenForMap);
    }, []);
    return (
        <Row>
            <Col span={4} style={{ padding: '10px' }}>
                <ClusterPanel />
                <RowSpacing />
                <PositionFiltrePanel />
            </Col>
            <Col span={16}>
                <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
                    <GoogleMaps />
                </APIProvider>
            </Col>
            <Col span={4} style={{ padding: '10px' }}>
                <OfflineFilterPanel />
                <RowSpacing />
                <ListScreenPanel />
            </Col>
        </Row>
    );
};

export default ScreenStatusMapView;
